if (!customElements.get('doctor-drawer')) {
  customElements.define('doctor-drawer', class DoctorDrawer extends HTMLElement {
    constructor() {
      super();
      
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.closeButton = this.querySelector('.drawer__close');

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hide());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.hide());
      }

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    hide() {
      console.log('Hiding drawer');
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.dispatchEvent(new CustomEvent('openBar'));
    }

    show() {
      console.log('Showing drawer');
      this.classList.add('active');
      
      if (document.querySelector('.header-wrapper.header-fixed')) {
        const t = document.querySelector('.header-wrapper.header-fixed').clientHeight;
        this.style.top = `${t}px`;
      }

      document.body.classList.add('overflow-hidden');
      document.dispatchEvent(new CustomEvent('closeBar'));
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 767) {
    const triggers = document.querySelectorAll(".doctor-trigger");
    
    triggers.forEach(trigger => {
      trigger.addEventListener("click", () => {
        const drawerId = trigger.getAttribute("data-drawer");
        const drawer = document.querySelector(`doctor-drawer[data-drawer="${drawerId}"]`);
        
        if (drawer) {
          drawer.show();
        }
      });
    });
  }
});
